








































import { computed, defineComponent, ref, Ref } from '@vue/composition-api';
import cButton                                 from '@/components/form/button/button.component.vue';
import cForm                                   from '@/components/form/form/form.component.vue';
import cFormItem                               from '@/components/form/form-item/form-item.component.vue';
import cInput                                  from '@/components/form/input/input.component.vue';
import cIconUser                               from '@/components/icons/icon-user.component.vue';
import cIconLock                               from '@/components/icons/icon-lock.component.vue';
import { GlobalContexts, useGlobals }          from '@/hooks/use-globals';
import useLoginFormHook                        from '@/views/login/hooks/use-login-form.hook';
import { Computed, ValidationRule }            from '@/types';

export default defineComponent({
  name: 'cLoginForm',
  components: {
    cButton,
    cForm,
    cFormItem,
    cInput,
    cIconUser,
    cIconLock,
  },
  setup() {
    const { i18n, store }: GlobalContexts = useGlobals();
    const buttonName: Ref<string> = ref(i18n.t(`${store.state.i18n.GLOBAL_PATH}.buttons.login`)
      .toString());

    const {
      loginFormFields,
      loginFormRef,
      getLoginFormErrors,
      activeField,
      listeners,
      onSubmit,
    } = useLoginFormHook();


    const rules: Computed<{ [ key: string ]: ValidationRule[] }> = computed(() => ({
      username: [
        {
          required: true,
          message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Username' ])
            .toString(),
          trigger: 'submit',
        },
      ],
      password: [
        {
          required: true,
          message: i18n.t(`${store.state.i18n.GLOBAL_PATH}.rules.required`, [ 'Password' ])
            .toString(),
          trigger: 'submit',
        },
      ],
    }));

    return {
      i18n,
      buttonName,
      listeners,
      activeField,
      loginFormFields,
      loginFormRef,
      onSubmit,
      rules,
      getLoginFormErrors,
    };
  },
});
